import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import ServiceImage from '../assets/imgs/featuredServicesImgs/service-image.svg'
import '../styles/Modal.scss'
import AddressModal from './AddressModal'
import { Grid } from '@mui/material'
import AddChargesModal from '../modals/AddChargesModal'
import { useNavigate } from 'react-router-dom'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  //   width: 400,
  outline: 'none',
  maxHeight: '90vh',
  overflow: 'auto',
  background:
    'transparent linear-gradient(180deg, #01CED1 0%, #14B1E4 51%, #2992FB 100%) 0% 0% no-repeat padding-box',
  // border: "2px solid #fff",
  boxShadow: '0px 5px 20px #00000040',
  p: 3,
  borderRadius: '16px',
  textAlign: 'center',
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#08C4BB',
    },
  },
  typography: {
    fontFamily: [
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontSize: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          background:
            'transparent linear-gradient(180deg, #01CED1 0%, #14B1E4 44%, #2992FB 100%) 0% 0% no-repeat padding-box',
          borderRadius: '10px',
          opacity: 1,
          height: '48px',
          color: '#fff',
          textTransform: 'capitalize',
        },
        '&:hover': {
          // backgroundColor: '#000'
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: 'primary',
          borderRadius: '16px',
          '&.Mui-checked': {
            color: '#2597F6',
          },
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          border: '1px solid #fff',
          borderRadius: '16px',
          boxShadow: '0px 5px 20px #00000040',
          backdropFilter: 'blur(10px)',
        },
      },
    },
  },
})

const ServicesModal = ({ handleServicesModal, modalOpen = false, screenName = '' }) => {
  const navigate = useNavigate()
  const [addressModal, setAddressModal] = React.useState(false)
  const toggleAddressModal = (toggleModal) => setAddressModal(toggleModal)

  const [addChargesModal, setAddChargesModal] = React.useState(false)
  const handleAddChargesModal = () => {
    if (
      screenName !== '' &&
      (screenName === 'client-home-screen' || screenName === 'client-profile')
    ) {
      navigate('/client-search')
      return
    }
    if (modalOpen) {
      handleServicesModal(false)
    }
    setAddChargesModal(!addChargesModal)
  }

  React.useEffect(() => {
    if (addressModal) {
      handleServicesModal(false)
    }
  }, [addressModal])

  return (
    <ThemeProvider theme={theme}>
      {/* <div> */}
      <>
        <Modal
          open={modalOpen}
          onClose={() => handleServicesModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className="services-modal">
            <div className="text-center">
              <h3 className="service-modal service-modal-title mb-3 text-white">
                Barber
              </h3>
              <Grid container rowSpacing={3} columnSpacing={3}>
                <Grid item xs={12} sm={6} md={6}>
                  <div
                    className="service pointer"
                    onClick={handleAddChargesModal}
                  >
                    <img src={ServiceImage} alt="" />
                    <p className="service-name fs-18 mt-3">Hair Cut</p>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <div className="service">
                    <img src={ServiceImage} alt="" />
                    <p className="service-name fs-18 mt-3">Hair Design</p>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <div className="service">
                    <img src={ServiceImage} alt="" />
                    <p className="service-name fs-18 mt-3">Shaving</p>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <div className="service">
                    <img src={ServiceImage} alt="" />
                    <p className="service-name fs-18 mt-3">Beard & Mustache</p>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <div className="service">
                    <img src={ServiceImage} alt="" />
                    <p className="service-name fs-18 mt-3">Shape Up</p>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Box>
        </Modal>
        <AddressModal
          toggleAddressModal={toggleAddressModal}
          modalOpen={addressModal}
        />
        <AddChargesModal
          toggleAddChargesModal={handleAddChargesModal}
          modalOpen={addChargesModal}
        />
      </>
    </ThemeProvider>
  )
}

export default ServicesModal
